
export default 'MozAppearance' in document.documentElement.style;
